module.exports = __webpack_public_path__ + "media/images/agreements/link_1-8256d66570a300f3f08feee0390b9a1e.png";